import React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';

const PrivateRoute: React.FC<RouteProps> = ({ render, ...rest }) => {
  const isAuthed = sessionStorage.getItem('bs_authed') === '1';

  return <Route {...rest} render={(props) => (isAuthed ? render?.(props) : <Redirect to="/bs/login" />)} />;
};

export default PrivateRoute;
